import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { IncidentMedicalAlertModel } from '../models/incident-medical-alert.model';
import { MedicalAlertType } from '../models/medical-alert-type.model';
import { IncidentMedicalAlertService } from '../services/medical-alert-incident.service';
import { CustomerIndividualMedicalAlertType } from '../../customer/models/enums/customer-individual-medical-alert-type.enum';
import { IncidentTypeService } from '../services/incident-type.service';
import { IncidentDialogContext } from '../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../incident-modal.component';
import { IncidentService } from '../services/incident.service';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ProhibitionService } from '../../prohibition/services/prohibition.service';
import { Jurisdiction } from 'app/foundation/models/enums/jurisdiction.enum';
import { CustomerLookupService } from 'app/customer/customer-lookups.service';
import { first } from 'rxjs/operators';
import { EnumDataService } from '../services/enums.DataService';

@Component({
    templateUrl: './medical-alert-incident-modal.html'
})
export class MedicalAlertModalComponent extends IncidentModalComponent<IncidentMedicalAlertModel> {

    // Lookups
    public citingAgencyTypes: any[];
    public dispositionCodeTypes: any[];
    public accidentTypes: any[];
    public courtOrderedInterlockMonthsTypes: any[];
    public courtActionFlagTypes: any[];
    public courtActionCodeTypes: any[];
    public courtOrderedActionTypes: any[];
    public civilCriminalViolationTypes: any[];
    public drugViolationTypeTypes: any[];
    public courts: any[];
    public plateTypes: any[];
    public vehicleJurisdictions: any[];
    public medicalAlertTypes: any[];
    public visionAlertTypes: any[];
    public alertTypes: any[];
    private lookUpService: CustomerLookupService;
    public jurisdictions: any;

    constructor(
        public service: IncidentMedicalAlertService,
        public dialogRef: MatDialogRef<IncidentModalComponent<IncidentMedicalAlertModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<IncidentMedicalAlertModel>,
        public incidentService: IncidentService,
        public prohibitionService: ProhibitionService,
        fb: UntypedFormBuilder,
        location: PlatformLocation,
        lookUpService: CustomerLookupService,
        typeService: IncidentTypeService,
        modalService: MvdModalService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);

        this.service = service;
        this.lookUpService = lookUpService;
        this.hasCdlCheckboxOnForm = true;

        lookUpService.getData('individual').pipe(first())
            .subscribe(
                r => this.jurisdictions = r.result.jurisdictions,
                e => {
                    console.log('error', e);
                });
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: IncidentMedicalAlertModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;

        setTimeout(() => {
            this.incidentForm.get('isCDLHolder').setValue(this.data.incident.cdlHolderIndicator);
            this.incidentForm.get('driverLicenseNumber').setValue(this.data.incident.driverLicenseNumber);
            this.incidentForm.get('driverLicenseJurisdiction').setValue(this.data.incident.driverLicenseJurisdictionId);
        }, 350);

        callback();
    }

    protected onLoadLookups(callback: (error?) => void): void {

        this.service.getLookups().subscribe(r => this.onGetLookups(r.result, callback), callback);

    }

    private onGetLookups(result: any, callback: (error?) => void): void {
        var self = this;

        let lookups: any;

        lookups = result;

        this.citingAgencyTypes = lookups.citingAgencyTypes;
        this.dispositionCodeTypes = lookups.dispositionCodeTypes;
        this.accidentTypes = lookups.accidentTypes;
        this.courtOrderedInterlockMonthsTypes = lookups.courtOrderedInterlockMonthsTypes;
        this.courtActionFlagTypes = lookups.courtActionFlagTypes;
        this.courtActionCodeTypes = lookups.courtActionCodeTypes;
        this.courtOrderedActionTypes = lookups.courtOrderedActionTypes;
        this.civilCriminalViolationTypes = lookups.civilCriminalViolationTypes;
        this.drugViolationTypeTypes = lookups.drugViolationTypeTypes;
        this.courts = lookups.courts;
        this.plateTypes = lookups.plateTypes;
        this.vehicleJurisdictions = lookups.vehicleJurisdictions;
        this.medicalAlertTypes = lookups.medicalAlertTypes;
        this.visionAlertTypes = lookups.visionAlertTypes;

        if (this.incidentType != null){
            if (this.data.incident.incidentTypeId == this.incidentType.find(x => x.incidentTypeValue == 'MedicalReportRequired').id) {
                this.alertTypes = lookups.medicalAlertTypes;
            } else if (this.data.incident.incidentTypeId == this.incidentType.find(x => x.incidentTypeValue == 'VisionReportRequired').id) {
                this.alertTypes = lookups.visionAlertTypes;
            }
        }

        callback();
    }

    protected onSaveIncident(callback: (error?: any) => void): void {
        this.data.incident.cdlHolderIndicator = this.incidentForm.get('isCDLHolder').value;
        this.data.incident.driverLicenseNumber = this.incidentForm.get('driverLicenseNumber').value;
        this.data.incident.driverLicenseJurisdictionId = this.incidentForm.get('driverLicenseJurisdiction').value;

        if (this.data.incident.cdlHolderIndicator == null) {
            this.data.incident.cdlHolderIndicator = false;
        }

        this.service.saveIncident(this.data.incident)
            .subscribe(r => {  }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId)
            .subscribe(result => { }, e => this.handleError, () => {
                this.dialogRef.close(true);
            });
    }

    public addMedicalAlert() {
        var self = this;
        const medicalAlerts: CustomerIndividualMedicalAlertType = new CustomerIndividualMedicalAlertType();
        const selectedObject = this.incidentForm.get('medicalAlertTypeList').value;

        if (selectedObject.value > 0) {
            const selectedTypes = self.getSelectedTypes(selectedObject.value);

            if (selectedTypes.length == 0) {
                const medType = medicalAlerts.FromId(selectedObject.value);

                const type = new MedicalAlertType();
                type.medicalAlertTypeId = medType.id;
                type.medicalAlertTypeDisplayValue = medType.displayValue;

                self.data.incident.medicalAlertTypes.push(type);
            }

            this.incidentForm.get('medicalAlertTypeList').reset();
        }
    };

    public deleteMedicalAlert(id) {
        var self = this;
        const medicalAlerts: CustomerIndividualMedicalAlertType = new CustomerIndividualMedicalAlertType();

        if (id > 0) {
            this.data.incident.medicalAlertTypes = this.data.incident.medicalAlertTypes.filter(x => x.medicalAlertTypeId != id);
        }
    };

    getSelectedTypes(id) {
        return this.data.incident.medicalAlertTypes.filter(x => x.medicalAlertTypeId == id);
    }
}
